module.exports = __webpack_public_path__ + "img/bgColor.742261a1.png";